var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { getScrollElement, onViewportScroll } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as NavigationUp } from '../../../resources/assets/components/arrow-up-navigation.svg';
import BackToTopAPI from './back-to-top-api.js';
import './back-to-top.css';
let BackToTop = class BackToTop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
        this.updateVisibility = () => {
            const { minVisibleHeight } = this.props;
            const { visible } = this.state;
            const scrollPercentage = this.getScrollPercentage();
            if (!visible && scrollPercentage >= minVisibleHeight) {
                this.setState({ visible: true });
            }
            else if (visible && scrollPercentage < minVisibleHeight) {
                this.setState({ visible: false });
            }
        };
        this.onClick = () => {
            this.viewport.scrollTo({ behavior: 'smooth', top: 0 });
        };
        this.viewport = getScrollElement();
        this.unlisten = onViewportScroll(this.updateVisibility);
    }
    componentDidMount() {
        this.updateVisibility();
    }
    componentDidUpdate(prevProps) {
        const { minVisibleHeight } = this.props;
        if (minVisibleHeight !== prevProps.minVisibleHeight) {
            this.updateVisibility();
        }
    }
    componentWillUnmount() {
        this.unlisten && this.unlisten();
    }
    getScrollPercentage() {
        const { clientHeight, scrollHeight, scrollTop } = this.viewport;
        const onePercent = (scrollHeight - clientHeight) / 100;
        const scrollPercentage = Math.ceil(scrollTop / onePercent);
        return scrollPercentage || 0;
    }
    renderButton() {
        const { visible } = this.state;
        if (!visible) {
            return null;
        }
        return (React.createElement("button", { className: "c-back-to-top", onClick: this.onClick },
            React.createElement(NavigationUp, { fill: "#FFF" })));
    }
    render() {
        return this.renderButton();
    }
};
BackToTop.propTypes = {
    minVisibleHeight: number,
};
BackToTop.defaultProps = {
    minVisibleHeight: 0,
};
BackToTop = __decorate([
    AwesomeComponent({ api: BackToTopAPI, type: ComponentType.NAVIGATION }),
    __metadata("design:paramtypes", [Object])
], BackToTop);
export default BackToTop;
//# sourceMappingURL=back-to-top.js.map